import '../../../node_modules/core-js/modules/es.array.iterator.esm.js';
import '../../../node_modules/core-js/modules/web.dom-collections.iterator.esm.js';
import React, { useState } from 'react';
import AccountPicker from '../account-picker/account-picker.esm.js';
import useTemplate from './hooks/use-template.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const TemplateLoaderContext = /*#__PURE__*/React.createContext({
  setSelectedTemplate: () => {
    // do nothing
  }
});
const useTemplateLoader = () => React.useContext(TemplateLoaderContext);
const TemplateLoaderProvider = props => {
  const {
    children
  } = props;
  const [selectedTemplate, setSelectedTemplate] = useState({
    metadataId: null
  });
  return /*#__PURE__*/jsxs(TemplateLoaderContext.Provider, {
    value: {
      setSelectedTemplate
    },
    children: [children, /*#__PURE__*/jsx(TemplateLoader, {
      selectedTemplate: selectedTemplate,
      setSelectedTemplate: setSelectedTemplate
    })]
  });
};
const TemplateLoader = ({
  selectedTemplate,
  setSelectedTemplate,
  onTemplateCopy
}) => {
  const [isAccountPickerVisible, onAccountPickerLoaded, onAccountPickerSubmit, onAccountPickerCancel, onAccountPickerError] = useTemplate(selectedTemplate, setSelectedTemplate, onTemplateCopy);
  return selectedTemplate.metadataId ? /*#__PURE__*/jsx(AccountPicker, {
    isVisible: isAccountPickerVisible,
    onLoaded: onAccountPickerLoaded,
    onSubmit: onAccountPickerSubmit,
    onCancel: onAccountPickerCancel,
    onError: onAccountPickerError
  }) : null;
};

export { TemplateLoader, TemplateLoaderContext, TemplateLoaderProvider, useTemplateLoader };
